import { render } from "./AddAccountDialog.vue?vue&type=template&id=85f42b72&ts=true"
import script from "./AddAccountDialog.vue?vue&type=script&lang=ts"
export * from "./AddAccountDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__